import { CSSProperties } from 'react';
import { RouterProps } from 'react-router';
import { IDraggable } from '../../components/common/DragSource/DragSource.types';
import { OpenSource } from '../../constants/Bi';
import { SettingsLayout } from '../../constants/Layout';
import { TSelectRecommendedCategories } from '../../utils/hoc/extended-sources/withMediaHome';
import { IWithFolderPathInner } from '../../utils/hoc/withFolderPath/withFolderPath.types';
import { IWithItemsActionsInner } from '../../utils/hoc/withItemsActions/withItemsActions.types';
import { IMMGRSettingsProps } from '../../utils/hoc/withMMGRSettings/withMMGRSettings.types';
import { MediaManagerSDKPublicMediaFolder } from '../../utils/hoc/withPublicMedia/withPublicMedia.types';
import { ILoadingError } from '../../utils/hooks/useLoadingErrorCatcher/useLoadingErrorCatcher.types';
import { ISearchBIParams } from '../../utils/hooks/useSearchBIParams';
import {
  MediaManagerSDKAnyItem,
  MediaManagerSDKFile,
  MediaManagerSDKFolder,
  MediaManagerSDKResponse,
} from '../../utils/media-manager-sdk';

export interface IInner extends IMMGRSettingsProps, IWithItemsActionsInner {
  isLoadingRecentItems: boolean;
  isLoadingRecommendedItems: boolean;
  recentItems: MediaManagerSDKAnyItem[];
  recommendedItems: MediaManagerSDKAnyItem[];
  recommendedADITitle: string;
  selectedItems: MediaManagerSDKAnyItem[];
  items: MediaManagerSDKAnyItem[];
  demonstrationThumbnailStyle: CSSProperties;
  handleItemClick(): void;
  isItemSelected(id: string): boolean;
  openSource: OpenSource;
}

export interface IOuter extends IDraggable {
  currentFolder: MediaManagerSDKFolder;
  recommendedItems: MediaManagerSDKAnyItem[];
  fileType: string;
  isSecure: boolean;
  publicMediaCurrentCategory: MediaManagerSDKPublicMediaFolder;
  isLoading: boolean;
  recommendedCategories: string[];
  recommendedCategoriesError: string;
  isRecommendedCategoriesLoading: boolean;
  searchQuery: string;
  searchBiParams: ISearchBIParams;
  navigateTo: RouterProps['history']['push'];
  prependItems(items: MediaManagerSDKAnyItem[]): void;
  privateItemInfoMP(fileName: string): MediaManagerSDKResponse<MediaManagerSDKFile[]>;
  buyItem(item: MediaManagerSDKFile): void;
  selectRecommendedCategories: TSelectRecommendedCategories;
  openFolderById: IWithFolderPathInner['openFolderById'];
  refreshFolder(): void;
  settingsLayout: SettingsLayout;
  updateFolderInPath(folderId: string, props: any): void;
  loadingError: ILoadingError;
  trackMediaManagerMediaPurchaseCompleted(): void;
}

export enum EditingToolName {
  VideoMaker = 'video_maker_open',
  PhotoStudio = 'photo_studio_open',
}
